<template>
  <div>
    <country-flag v-if="data" :country="data" :size="size" class="flag" />
  </div>
</template>

<script>
import CountryFlag from "vue-country-flag";
import { mapGetters } from "vuex";

export default {
  props: {
    size: {
      type: String,
      default: "normal"
    }
  },
  components: {
    CountryFlag
  },
  computed: {
    ...mapGetters({
      country: "getEmployeeLang"
    }),
    data() {
      if (this.country) return this.country;

      const userLang =
        navigator.language ||
        navigator.userLanguage ||
        navigator.browserLanguage ||
        navigator.systemLanguage;

      if (typeof userLang !== "undefined") {
        return userLang.indexOf('-') !== -1? userLang.split("-")[1].toLowerCase() : userLang;
      }

      return "ru";
    }
  }
};
</script>

<style scoped lang="scss">
.flag {
  clip-path: circle(30% at 50% 50%);
}
</style>